import {
    makeStyles,
    createStyles,
    Theme,
} from '@bb-ui/react-library/dist/components/styles';

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        paper: {
            minHeight: '70vh',
        },
        loadingIndicator: {
            paddingTop: theme.spacing(4),
        },
        mainBox: {
            overflow: 'visible',
            marginBottom: `-${theme.spacing(1)}px`,
            paddingTop: theme.spacing(1),
        },
        breadcrumbLink: {
            cursor: 'pointer',
        },
        searchAndCreate: {},
        searchAndCreateSubtext: {
            marginBottom: theme.spacing(2),
        },
        usernameTextFieldWrapper: {
            marginBottom: theme.spacing(2),
        },
        usernameTextField: {
            [theme.breakpoints.only('xs')]: {
                width: '100%',
            },
            width: '250px',
        },
        idpSelectField: {
            [theme.breakpoints.only('xs')]: {
                width: '100%',
            },
            width: '250px',
            marginBottom: theme.spacing(2),
            textOverflow: 'ellipsis',
        },
        createUserButton: {},
        errorMessage: {
            background: 'rgba(255, 0, 0, 0.2)',
            marginTop: theme.spacing(2),
            color: 'black',
            padding: theme.spacing(2),
            paddingLeft: theme.spacing(4),
        },
    }),
);
